/* Support-Widget mit Flows – ersetzt das Gorgias-Chat-Widget.
 * Konfiguration: <script type="application/json" id="gsw-config"> (aus sections/support-widget.liquid)
 * Flow-Daten:   Metaobjects "support_flow" (via ?section_id=support-widget-data) oder Fallback-JSON-Asset.
 */
(function () {
  'use strict';
  if (window.__gswLoaded) return;
  window.__gswLoaded = true;

  var cfgEl = document.getElementById('gsw-config');
  if (!cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { console.warn('[Support-Widget] Konfiguration fehlerhaft', e); return; }

  var T = Object.assign({
    home_heading: 'Wie können wir dir helfen?',
    intro_default: 'Klar! Womit können wir Dir helfen?',
    order_status: 'Bestellstatus',
    order_heading: 'Bestellstatus',
    order_text: 'Melde dich mit deiner E-Mail-Adresse an, um den Status und die Sendungsverfolgung deiner Bestellungen zu sehen.',
    order_button: 'Zu meinen Bestellungen',
    privacy: 'Datenschutz',
    contact_label: 'Sende uns eine Nachricht',
    contact_intro: 'So erreichst du uns – wir helfen dir gerne weiter:',
    contact_button: 'Zum Kontaktformular',
    helpful_q: 'War das hilfreich?',
    helpful_yes: 'Ja, danke sehr',
    helpful_no: 'Nein, ich brauche noch Hilfe',
    helpful_thanks: 'Super, das freut uns! Wenn du noch etwas wissen möchtest, sind wir gerne für dich da. 🤍',
    go_back: 'Zurückgehen',
    back_to_start: 'Zurück zum Start',
    open_label: 'Hilfe & Kontakt öffnen',
    close_label: 'Schließen',
    back_label: 'Zurück'
  }, cfg.labels || {});
  Object.keys(T).forEach(function (k) { if (T[k] == null) delete T[k]; });

  var STORE_KEY = 'gsw-state';
  var logoPre = null;
  var CONTACT_ID = '__kontakt', NO_ID = '__nein', YES_ID = '__ja';
  var REDUCED = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DELAY_TYPING = REDUCED ? 0 : (cfg.typing_ms != null ? cfg.typing_ms : 900);   // Tipp-Animation vor jeder Antwort
  var DELAY_OPTIONS = REDUCED ? 0 : (cfg.options_ms != null ? cfg.options_ms : 700); // Buttons erscheinen danach

  /* ---------------- helpers ---------------- */
  function h(tag, attrs, children) {
    var el = document.createElement(tag);
    if (attrs) for (var k in attrs) {
      if (attrs[k] == null || attrs[k] === false) continue;
      if (k === 'class') el.className = attrs[k];
      else if (k === 'html') el.innerHTML = attrs[k];
      else if (k === 'text') el.textContent = attrs[k];
      else if (k.slice(0, 2) === 'on') el.addEventListener(k.slice(2), attrs[k]);
      else el.setAttribute(k, attrs[k] === true ? '' : attrs[k]);
    }
    (children || []).forEach(function (c) { if (c) el.appendChild(typeof c === 'string' ? document.createTextNode(c) : c); });
    return el;
  }
  var ICON = {
    chat: '<svg viewBox="0 0 56 56" aria-hidden="true"><path class="ic" d="M28 0c15.5 0 28 12.5 28 28S43.5 56 28 56c-4.5 0-8.7-1-12.4-2.9C10.3 55.3 4.6 56.1.7 56c-.7 0-.9-.9-.3-1.4 3.4-2.5 5.6-5.1 6.9-7.8C2.8 41.8 0 35.2 0 28 0 12.5 12.5 0 28 0z"/><circle class="dot" cx="18" cy="28" r="2.5"/><circle class="dot" cx="28" cy="28" r="2.5"/><circle class="dot" cx="38" cy="28" r="2.5"/></svg>',
    close: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 7l10 10M17 7L7 17" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>',
    down: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14m-6-6 6 6 6-6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    back: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M14 7l-5 5 5 5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    arrow: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 12h15m-5-5 5 5-5 5" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    email: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="5.5" width="18" height="13" rx="1.5" fill="none" stroke="currentColor" stroke-width="1.4"/><path d="M3.5 6.5l8.5 7 8.5-7" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/></svg>',
    whatsapp: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3.2a8.8 8.8 0 0 0-7.6 13.2L3.2 20.8l4.5-1.2A8.8 8.8 0 1 0 12 3.2z" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/><path d="M9.2 8.3c.2-.4.4-.4.6-.4h.5c.2 0 .4 0 .5.4l.7 1.7c.1.2 0 .4-.1.5l-.5.6c-.1.1-.2.3 0 .5.4.7 1 1.3 1.6 1.8.6.4 1.1.7 1.4.8.2.1.4 0 .5-.1l.6-.8c.1-.2.3-.2.5-.1l1.6.8c.2.1.3.2.3.4 0 .4-.1 1-.5 1.3-.4.4-1.1.8-1.8.7-.7 0-2.2-.5-3.6-1.7-1.6-1.4-2.6-3.1-2.8-3.7-.2-.6-.1-1.6.9-2.6z" fill="currentColor"/></svg>',
    phone: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6.6 3.5l2.6 3.3c.3.4.3 1 0 1.4L7.8 10a12.5 12.5 0 0 0 6.2 6.2l1.8-1.4c.4-.3 1-.3 1.4 0l3.3 2.6c.5.4.5 1.1.1 1.5l-1.5 1.6c-.6.6-1.5.8-2.3.5A18.5 18.5 0 0 1 3.9 8.1c-.3-.8-.1-1.7.5-2.3L6 4.3c.2-.4.4-.8.6-.8z" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/></svg>'
  };
  function svg(name) { var s = h('span', { html: ICON[name] || '' }); return s.firstChild; }
  function store(obj) { try { sessionStorage.setItem(STORE_KEY, JSON.stringify(obj)); } catch (e) {} }
  function restore() { try { return JSON.parse(sessionStorage.getItem(STORE_KEY) || 'null'); } catch (e) { return null; } }
  function pathOf(href) {
    try { var u = new URL(href, location.href); return u.origin === location.origin ? u.pathname.replace(/\/$/, '') : null; }
    catch (e) { return null; }
  }
  var contactPath = pathOf(cfg.contact_url || '/pages/kontakt');
  var root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';

  /* ---------------- DOM ---------------- */
  var host = h('div', { id: 'gsw-root', 'data-position': cfg.position || 'left' });
  var shadow = host.attachShadow ? host.attachShadow({ mode: 'open' }) : host;
  // unsichtbar bis das CSS geladen ist (kein ungestylter Button)
  host.style.visibility = 'hidden';
  function reveal() { host.style.visibility = ''; }
  if (cfg.css_url) {
    var cssLink = h('link', { rel: 'stylesheet', href: cfg.css_url });
    cssLink.addEventListener('load', reveal);
    cssLink.addEventListener('error', reveal);
    shadow.appendChild(cssLink);
  } else { reveal(); }
  if (cfg.inline_css) shadow.appendChild(h('style', { text: cfg.inline_css }));

  var launcher = h('button', { class: 'launcher', type: 'button', 'aria-label': T.open_label, 'aria-expanded': 'false', 'aria-controls': 'gsw-panel', html: ICON.chat });
  var panel = h('div', { class: 'panel', id: 'gsw-panel', role: 'dialog', 'aria-label': T.home_heading, 'aria-hidden': 'true' });
  var bg = h('div', { class: 'bg', 'aria-hidden': 'true' });
  var barEl = h('div', { class: 'bar' });
  var bodyEl = h('div', { class: 'body' });
  var footEl = h('div', { class: 'foot' });
  var scrim = h('div', { class: 'scrim' });
  var sheet = h('div', { class: 'sheet', role: 'dialog', 'aria-modal': 'true', hidden: true });
  var toBottom = h('button', { class: 'to-bottom', type: 'button', 'aria-label': 'Nach unten', html: ICON.down });
  [bg, barEl, bodyEl, toBottom, footEl, scrim, sheet].forEach(function (e) { panel.appendChild(e); });
  function updateToBottom() {
    var far = panel.classList.contains('is-chat') && (bodyEl.scrollHeight - bodyEl.clientHeight - bodyEl.scrollTop > 60);
    toBottom.classList.toggle('show', far);
  }
  bodyEl.addEventListener('scroll', function () { requestAnimationFrame(updateToBottom); }, { passive: true });
  toBottom.addEventListener('click', function () { bodyEl.scrollTo({ top: bodyEl.scrollHeight, behavior: 'smooth' }); });
  shadow.appendChild(panel); shadow.appendChild(launcher);

  if (cfg.logo_width) host.style.setProperty('--gsw-logo-w', cfg.logo_width + 'px');
  if (cfg.colors) for (var c in cfg.colors) if (cfg.colors[c]) host.style.setProperty('--gsw-' + c, cfg.colors[c]);

  /* ---------------- data ---------------- */
  var data = null, loading = null, byId = {}, parentOf = {};
  function index(node, parent) {
    byId[node.id] = node; if (parent) parentOf[node.id] = parent;
    (node.children || []).forEach(function (ch) { index(ch, node); });
  }
  function useData(d) {
    if (!d || !d.children || !d.children.length) throw new Error('empty');
    data = d; byId = {}; parentOf = {}; index(d, null);
    byId[CONTACT_ID] = { id: CONTACT_ID, title: T.contact_label, action: 'kontakt' };
    byId[NO_ID] = { id: NO_ID, title: T.helpful_no, action: 'kontakt' };
    byId[YES_ID] = { id: YES_ID, title: T.helpful_yes, action: 'danke' };
  }
  function fetchJSON(url) { return fetch(url, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); }); }
  function load() {
    if (data) return Promise.resolve(data);
    if (loading) return loading;
    if (cfg.data) { useData(cfg.data); return Promise.resolve(data); }
    var fromSection = cfg.section_id
      ? fetch(root + '?section_id=' + encodeURIComponent(cfg.section_id), { credentials: 'same-origin' })
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var s = doc.querySelector('script[data-gsw-data]');
            var d = JSON.parse(s ? s.textContent : 'null');
            if (!d || d.fallback) throw new Error('no metaobjects');
            return d;
          })
      : Promise.reject(new Error('no section'));
    loading = fromSection
      .catch(function () { if (!cfg.fallback_url) throw new Error('no data'); return fetchJSON(cfg.fallback_url); })
      .then(function (d) { useData(d); return data; })
      .catch(function (e) { loading = null; throw e; });
    return loading;
  }

  /* ---------------- state ---------------- */
  var path = [];       // ids ab Start (ohne Root)
  var isOpen = false;
  var timers = [];
  function clearTimers() { timers.forEach(clearTimeout); timers = []; }
  function later(fn, ms) { if (!ms) { fn(); return; } timers.push(setTimeout(fn, ms)); }
  function node(id) { return byId[id]; }
  function current() { return path.length ? node(path[path.length - 1]) : data; }
  function persist() { store({ path: path }); }

  /* ---------------- building blocks ---------------- */
  function btn(cls, label, onclick, extra) {
    var b = h('button', Object.assign({ class: cls, type: 'button', onclick: onclick }, extra || {}));
    if (typeof label === 'string') b.textContent = label; else b.appendChild(label);
    return b;
  }
  function renderBar(chat) {
    barEl.innerHTML = '';
    if (chat) barEl.appendChild(btn('icon-btn', svg('back'), back, { 'aria-label': T.back_label }));
    barEl.appendChild(h('div', { class: 'spacer' }));
    if (cfg.show_order_status !== false) barEl.appendChild(btn('pill-btn', T.order_status, openOrderSheet));
    barEl.appendChild(btn('icon-btn', svg('close'), close, { 'aria-label': T.close_label }));
  }
  function logoEl() {
    var wrap = h('div', { class: 'logo' });
    var text = function () { return h('span', { class: 'logo-text', text: cfg.shop_name || '' }); };
    if (cfg.logo_url) {
      var lh = cfg.logo_height || (logoPre && logoPre.naturalWidth ? Math.round((cfg.logo_width || 155) * logoPre.naturalHeight / logoPre.naturalWidth) : null);
      var li = h('img', { src: cfg.logo_url, alt: cfg.shop_name || '', width: cfg.logo_width || 155, height: lh, decoding: 'sync' });
      li.addEventListener('error', function () { li.replaceWith(text()); });
      wrap.appendChild(li);
    } else wrap.appendChild(text());
    return wrap;
  }
  function wireLinks(scope) {
    scope.querySelectorAll('a[href]').forEach(function (a) {
      var p = pathOf(a.getAttribute('href'));
      if (p !== null && contactPath && p === contactPath) {
        a.addEventListener('click', function (e) { e.preventDefault(); go(CONTACT_ID); });
      } else if (p === null && /^https?:/i.test(a.getAttribute('href'))) {
        a.target = '_blank'; a.rel = 'noopener';
      }
    });
  }
  function answerEl(n) {
    var el = h('div', { class: 'bot', html: n.html || '' });
    if (n.image) {
      var src = n.image;
      if (!/^(https?:|data:|\/\/)/.test(src) && cfg.fallback_url) {
        try { src = new URL(src, new URL(cfg.fallback_url, location.href)).href; } catch (e) {}
      }
      var img = h('img', { src: src, alt: '', loading: 'lazy' });
      var ps = el.querySelectorAll('p');
      if (ps.length > 4) ps[3].after(img); else el.appendChild(img);
    }
    wireLinks(el);
    return el;
  }
  function contactEl() {
    var wrap = h('div', { class: 'bot wide' });
    wrap.appendChild(h('p', { text: T.contact_intro }));
    var cards = h('div', { class: 'cards' });
    (cfg.contacts || []).forEach(function (ct) {
      var card = h('div', { class: 'card' }, [
        h('div', { class: 'card-head' }, [svg(ct.icon || 'email'), h('span', { class: 'card-title', text: ct.title || '' })]),
        ct.text ? h('div', { class: 'card-text', html: ct.text }) : null
      ]);
      if (ct.url) {
        var ext = /^https?:/i.test(ct.url) && pathOf(ct.url) === null;
        var a = h('a', { class: 'card-link', href: ct.url, target: ext ? '_blank' : null, rel: ext ? 'noopener' : null }, [h('span', { text: ct.link_label || ct.url })]);
        a.appendChild(svg('arrow'));
        card.appendChild(a);
      }
      cards.appendChild(card);
    });
    wrap.appendChild(cards);
    if (cfg.contact_url && T.contact_button) wrap.appendChild(h('a', { class: 'primary', href: cfg.contact_url, text: T.contact_button }));
    return wrap;
  }
  function isLeaf(n) { return !(n.children && n.children.length) && !n.action; }

  // Bot-Antwort auf einen Schritt
  function botFor(n) {
    if (n.action === 'kontakt') return contactEl();
    if (n.action === 'danke') return h('div', { class: 'bot', text: T.helpful_thanks });
    if (n.children && n.children.length) return h('div', { class: 'bot', text: n.intro || T.intro_default });
    return answerEl(n);
  }
  // Nachfrage + Buttons nach dem aktuellen Schritt
  function followUp(n) {
    var frag = document.createDocumentFragment();
    var opts = h('div', { class: 'opts' });
    if (n.children && n.children.length) {
      n.children.forEach(function (ch) { opts.appendChild(btn('opt', ch.title, function () { go(ch.id); })); });
    } else if (isLeaf(n)) {
      frag.appendChild(h('div', { class: 'bot', text: T.helpful_q }));
      opts.appendChild(btn('opt', T.helpful_yes, function () { go(YES_ID); }));
      opts.appendChild(btn('opt', T.helpful_no, function () { go(NO_ID); }));
      opts.appendChild(btn('opt', T.go_back, back));
    } else {
      opts.appendChild(btn('opt', T.back_to_start, home));
      if (n.action === 'kontakt') opts.appendChild(btn('opt', T.go_back, back));
    }
    frag.appendChild(opts);
    return frag;
  }
  function typingEl() {
    return h('div', { class: 'typing', 'aria-label': 'schreibt …' }, [h('i'), h('i'), h('i')]);
  }

  /* ---------------- render ---------------- */
  var msgsEl = null, tailEl = null;

  function renderFoot() {
    footEl.innerHTML = '';
    footEl.appendChild(btn('link-btn', T.privacy, openPrivacySheet));
  }

  // kompletter Neuaufbau ohne Verzögerung (Öffnen, Zurück, Start)
  function renderStatic() {
    clearTimers();
    if (!data) return;
    var chat = path.length > 0;
    panel.classList.toggle('is-chat', chat);
    renderBar(chat);
    renderFoot();
    bodyEl.innerHTML = '';
    bodyEl.appendChild(logoEl());
    if (!chat) {
      var homeEl = h('div', { class: 'home' });
      homeEl.appendChild(h('h2', { text: data.title || T.home_heading }));
      var cats = h('div', { class: 'cats' });
      data.children.forEach(function (ch) { cats.appendChild(btn('cat', ch.title, function () { go(ch.id); })); });
      homeEl.appendChild(cats);
      bodyEl.appendChild(homeEl);
      bodyEl.scrollTop = 0;
      msgsEl = null;
      updateToBottom();
      return;
    }
    msgsEl = h('div', { class: 'msgs', 'aria-live': 'polite' });
    path.forEach(function (id) {
      var n = node(id); if (!n) return;
      msgsEl.appendChild(h('div', { class: 'user', text: n.title }));
      msgsEl.appendChild(botFor(n));
    });
    tailEl = h('div', { class: 'tail' }, [followUp(current())]);
    msgsEl.appendChild(tailEl);
    bodyEl.appendChild(msgsEl);
    anchorBottom(true);
    bodyEl.scrollTop = bodyEl.scrollHeight;
    updateToBottom();
  }

  // Nachrichten unten ausrichten: freien Platz einmal als Abstand oben setzen.
  // Neue Nachrichten verlängern danach nur den Inhalt, sichtbar wird per Scrollen – das zählt nicht als Layout-Verschiebung.
  // Umsetzung per transform: Transform-Änderungen zählen nicht als Layout-Verschiebung (CLS).
  function anchorBottom(instant) {
    if (!msgsEl) return;
    var free = bodyEl.clientHeight - (msgsEl.offsetTop + msgsEl.offsetHeight) - 12;
    if (instant) msgsEl.style.transition = 'none';
    msgsEl.style.transform = free > 0 ? 'translateY(' + free + 'px)' : '';
    if (instant) { void msgsEl.offsetHeight; msgsEl.style.transition = ''; }
  }
  function scrollTo(el) {
    requestAnimationFrame(function () {
      var max = bodyEl.scrollHeight - bodyEl.clientHeight;
      var top = max;
      // Frage darf nicht nach oben aus dem Bild rutschen, solange die Antwort gelesen wird
      if (el && max - (el.offsetTop - 70) > 0) top = Math.min(max, Math.max(0, el.offsetTop - 70));
      bodyEl.scrollTo({ top: top, behavior: REDUCED ? 'auto' : 'smooth' });
      setTimeout(updateToBottom, 450);
    });
  }

  // neuer Schritt mit Chat-Gefühl: Frage sofort, dann "tippt …", dann Antwort, dann Buttons
  function go(id) {
    var n = node(id); if (!n) return;
    clearTimers();
    var wasHome = path.length === 0;
    path.push(id); persist();
    if (wasHome || !msgsEl) {
      // Wechsel von der Startseite in die Chat-Ansicht
      panel.classList.add('is-chat');
      renderBar(true);
      bodyEl.innerHTML = '';
      bodyEl.appendChild(logoEl());
      msgsEl = h('div', { class: 'msgs', 'aria-live': 'polite' });
      bodyEl.appendChild(msgsEl);
      tailEl = null;
    }
    if (tailEl) tailEl.remove();
    var u = h('div', { class: 'user enter', text: n.title });
    msgsEl.appendChild(u);
    var typing = typingEl();
    tailEl = h('div', { class: 'tail' });
    msgsEl.appendChild(tailEl);
    anchorBottom(wasHome);
    later(function () { tailEl.appendChild(typing); anchorBottom(); scrollTo(u); }, DELAY_TYPING ? 250 : 0);
    later(function () {
      typing.remove();
      var b = botFor(n); b.classList.add('enter');
      msgsEl.insertBefore(b, tailEl);
      anchorBottom();
      scrollTo(u);
      later(function () {
        var f = followUp(n);
        var wrap = h('div', { class: 'fu enter' }, [f]);
        tailEl.appendChild(wrap);
        anchorBottom();
        if (b.offsetHeight < bodyEl.clientHeight * 0.6) scrollTo(u);
      }, DELAY_OPTIONS);
    }, DELAY_TYPING + (DELAY_TYPING ? 250 : 0));
    if (!DELAY_TYPING) scrollTo(u);
  }
  function back() { path.pop(); persist(); renderStatic(); }
  function home() { path = []; persist(); renderStatic(); }

  function renderLoading() {
    renderBar(false); renderFoot(); bodyEl.innerHTML = '';
    bodyEl.appendChild(logoEl());
    bodyEl.appendChild(h('div', { class: 'loading', 'aria-label': 'Lädt' }, [h('i'), h('i'), h('i')]));
  }

  /* ---------------- Bottom-Sheets (Bestellstatus, Datenschutz) ---------------- */
  var lastFocus = null;
  function openSheet(title, bodyNodes, action) {
    lastFocus = shadow.activeElement || null;
    sheet.innerHTML = '';
    var closeBtn = btn('icon-btn plain', svg('close'), closeSheet, { 'aria-label': T.close_label });
    sheet.appendChild(h('div', { class: 'sheet-head' }, [h('h3', { text: title, id: 'gsw-sheet-title' }), closeBtn]));
    sheet.setAttribute('aria-labelledby', 'gsw-sheet-title');
    bodyNodes.forEach(function (n) { if (n) sheet.appendChild(n); });
    if (action) sheet.appendChild(action);
    sheet.hidden = false;
    requestAnimationFrame(function () {
      sheet.classList.add('is-open'); scrim.classList.add('is-open');
      // Fokus ohne Scrollen setzen – sonst springt das Fenster, solange das Sheet noch unten ausfährt
      closeBtn.focus({ preventScroll: true });
      panel.scrollTop = 0;
    });
  }
  function openOrderSheet() {
    openSheet(T.order_heading, [T.order_text ? h('p', { text: T.order_text }) : null],
      h('a', { class: 'primary', href: cfg.order_status_url || '/account', text: T.order_button }));
  }
  function openPrivacySheet() {
    var p = h('p');
    var txt = T.privacy_text || 'Mit der Nutzung dieses Chats erklärst du dich mit unserer {link} einverstanden.';
    var parts = txt.split('{link}');
    p.appendChild(document.createTextNode(parts[0]));
    if (parts.length > 1) {
      p.appendChild(h('a', { href: cfg.privacy_url || '/policies/privacy-policy', target: '_blank', rel: 'noopener', text: T.privacy_link || 'Datenschutzrichtlinie' }));
      p.appendChild(document.createTextNode(parts[1]));
    }
    openSheet(T.privacy, [p], btn('primary', T.privacy_ok || 'Verstanden', closeSheet));
  }
  function closeSheet() {
    sheet.classList.remove('is-open'); scrim.classList.remove('is-open');
    setTimeout(function () { sheet.hidden = true; }, 300);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  scrim.addEventListener('click', closeSheet);

  /* ---------------- open / close ---------------- */
  function open() {
    if (isOpen) return;
    isOpen = true;
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    launcher.setAttribute('aria-expanded', 'true');
    host.classList.add('open');
    if (window.matchMedia('(max-width: 600px)').matches) document.documentElement.style.overflow = 'hidden';
    if (!data) renderLoading();
    load().then(function () {
      path = [];
      renderStatic();
      var first = shadow.querySelector('.cat, .opt');
      if (first && !('ontouchstart' in window)) first.focus({ preventScroll: true });
    }).catch(function () {
      if (cfg.contact_url) location.href = cfg.contact_url;
    });
  }
  function close() {
    if (!isOpen) return;
    isOpen = false;
    clearTimers();
    if (sheet.classList.contains('is-open')) closeSheet();
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    launcher.setAttribute('aria-expanded', 'false');
    host.classList.remove('open');
    document.documentElement.style.overflow = '';
    // beim nächsten Öffnen komplett neu starten
    msgsEl = null; tailEl = null; path = []; persist();
    launcher.focus({ preventScroll: true });
  }
  launcher.addEventListener('click', function () { isOpen ? close() : open(); });
  ['pointerenter', 'touchstart', 'focus'].forEach(function (ev) {
    launcher.addEventListener(ev, function () { load().catch(function () {}); }, { once: true, passive: true });
  });
  host.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (sheet.classList.contains('is-open')) closeSheet(); else close();
  });

  window.SupportWidget = { open: open, close: close, contact: function () { open(); load().then(function () { go(CONTACT_ID); }); } };
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href="#support-widget"]');
    if (a) { e.preventDefault(); open(); }
  });

  /* ---------------- Rücksicht auf das Theme ---------------- */
  // 1) ausblenden, solange Warenkorb, Menü, Filter oder Popups des Themes offen sind
  var hideClasses = String(cfg.hide_when_class != null ? cfg.hide_when_class : 'lock-all lock-mobile js-drawer-open')
    .split(/\s+/).filter(Boolean);
  // zusätzlich: offene Popups des Themes per Selektor erkennen (z. B. Impulse: tool-tip[data-tool-tip-open="true"])
  var hideSelector = cfg.hide_selector ? String(cfg.hide_selector).trim() : '';
  function popupOpen() {
    if (!hideSelector) return false;
    try { return !!document.querySelector(hideSelector); } catch (e) { return false; }
  }
  var coverQueued = false;
  function checkCovered() {
    coverQueued = false;
    var hc = document.documentElement.classList, bc = document.body.classList;
    var covered = hideClasses.some(function (c) { return hc.contains(c) || bc.contains(c); }) || popupOpen();
    if (isOpen && !covered) return;
    host.classList.toggle('covered', covered);
  }
  function queueCovered() { if (!coverQueued) { coverQueued = true; requestAnimationFrame(checkCovered); } }
  // 2) über fixierten Leisten unten (z. B. "In den Warenkorb"-Leiste auf dem Handy) schweben
  var liftQueued = false;
  function lift() {
    liftQueued = false;
    var off = 0;
    if (cfg.avoid_selector) {
      document.querySelectorAll(cfg.avoid_selector).forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.height && r.top < innerHeight && r.bottom >= innerHeight - 4) off = Math.max(off, innerHeight - r.top);
      });
    }
    // nur verschieben, wenn wirklich nötig – ein gesetztes translate würde sonst das Fenster beim Öffnen einengen
    host.style.translate = off > 0 ? '0 ' + (-Math.round(off)) + 'px' : '';
  }
  function queueLift() { if (!liftQueued) { liftQueued = true; requestAnimationFrame(lift); } }

  function hiddenHere() {
    var p = location.pathname.replace(/\/$/, '') || '/';
    var list = Array.isArray(cfg.hide_paths) ? cfg.hide_paths : String(cfg.hide_paths || '').split(/[\r\n,]+/);
    return list.some(function (x) {
      x = String(x).trim().replace(/\/$/, ''); if (!x) return false;
      return x.slice(-1) === '*' ? p.indexOf(x.slice(0, -1)) === 0 : p === (x || '/');
    });
  }

  function mount() {
    if (hiddenHere()) return;
    // Schrift des Themes übernehmen (ist bereits geladen – nichts zusätzlich)
    try {
      var ff = getComputedStyle(document.body).fontFamily;
      if (ff) host.style.setProperty('--gsw-font', ff);
    } catch (e) {}
    if (cfg.hide_mobile) host.classList.add('no-mobile');
    document.body.appendChild(host);
    var mo = new MutationObserver(queueCovered);
    mo.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    mo.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    if (hideSelector) {
      // nur die für Popups relevanten Attribute beobachten – kein Einfluss auf die Performance
      new MutationObserver(queueCovered).observe(document.body, { subtree: true, attributes: true, attributeFilter: ['open', 'data-tool-tip-open', 'aria-hidden', 'class'] });
    }
    checkCovered();
    window.addEventListener('scroll', queueLift, { passive: true });
    window.addEventListener('resize', queueLift);
    setTimeout(lift, 800);
    // Fragen im Leerlauf vorladen, damit beim ersten Klick keine Ladepunkte erscheinen
    setTimeout(function () { whenIdle(function () {
      load().catch(function () {});
      // Logo vorladen und dekodieren, damit es beim ersten Öffnen sofort da ist
      if (cfg.logo_url) { logoPre = new Image(); logoPre.decoding = 'async'; logoPre.src = cfg.logo_url; if (logoPre.decode) logoPre.decode().catch(function () {}); }
    }); }, 3000);
    if (cfg.auto_open) open();
  }
  // Erst nach dem Laden der Seite und wenn der Browser Leerlauf hat: kein Einfluss auf LCP
  function whenIdle(fn) {
    if ('requestIdleCallback' in window) requestIdleCallback(fn, { timeout: 2500 }); else setTimeout(fn, 300);
  }
  var delay = Math.max(0, (cfg.show_delay || 0) * 1000);
  function start() { whenIdle(function () { delay ? setTimeout(mount, delay) : mount(); }); }
  if (document.readyState === 'complete') start(); else window.addEventListener('load', start, { once: true });
})();
